
export enum EHRStyle {
  CHART_NOTE = 'chart-note',
  LEGACY_REGISTRATION = 'legacy',
  FLOWSHEET = 'flowsheet',
  POST_OP_LEGACY = 'post-op',
  ENCOUNTER_SCREENS = 'encounter-screens'
}

export interface PatientRecord {
  mrn: string;
  lastName: string;
  firstName: string;
  dob: string;
  gender: string;
}